// ======================================================================
// File Name       : CommonConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const SYSTEM_CREATE_FLAG = {
  USER: 0,
  SYSTEM: 1,
};

// Step 12.0.0 START
// ログイン後のSuperuser種別
export const SUPERUSER_LOGIN_TYPE = {
  NORMAL_SUPERUSER: 0,
  INTEGRATION_SUPERUSER: 1,
  INTEGRATION_ROOT_SUPERUSER: 2,
};
// Step 12.0.0 END
